(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wella-offer-band"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__wellaOfferBand) return;
    window.__wellaOfferBand = true;

    // Keep the offer on one line: shrink the font (down to 9px) instead of cutting the text with "...".
    // The separators are sized in em, so the needed size is proportional and one pass is usually enough.
    function fit() {
      document.querySelectorAll('.wco__line').forEach(function (line) {
        line.style.fontSize = '';
        var scroll = line.scrollWidth;
        var client = line.clientWidth;
        if (!client || scroll - client <= 0.5) return;
        var size = parseFloat(getComputedStyle(line).fontSize);
        size = Math.max(9, Math.floor(size * client / scroll * 2) / 2);
        line.style.fontSize = size + 'px';
        while (line.scrollWidth - line.clientWidth > 0.5 && size > 9) {
          size -= 0.5;
          line.style.fontSize = size + 'px';
        }
      });
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        fit();
      });
    }

    function start() {
      if (!document.querySelector('.wco__line')) return;
      fit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
      window.addEventListener('resize', schedule);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wella-offer-label"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__wellaOfferLabel) return;
    window.__wellaOfferLabel = true;

    // Shrink the label font until the text fits inside the label's max width (a third of the image).
    // All labels are measured together (reads, then writes) so a grid of cards costs a few layouts,
    // not a few per label. Everything inside the label is sized in em, so the first pass can compute
    // the fitting size directly; later passes only step down by half a pixel for rounding.
    function fitAll(labels) {
      var items = [];
      labels.forEach(function (label) {
        var text = label.querySelector('.wol__t');
        if (!text) return;
        label.style.fontSize = '';
        items.push({ label: label, text: text });
      });
      items.forEach(function (item) {
        item.size = parseFloat(getComputedStyle(item.label).fontSize);
      });
      for (var pass = 0; pass < 6 && items.length; pass++) {
        var over = [];
        items.forEach(function (item) {
          var scroll = item.text.scrollWidth;
          var client = item.text.clientWidth;
          if (scroll - client > 0.5 && item.size > 5) {
            item.scroll = scroll;
            item.client = client;
            // Layout width (offsetWidth), like scrollWidth/clientWidth: a scale() on the card must not skew it.
            item.width = item.label.offsetWidth;
            over.push(item);
          }
        });
        over.forEach(function (item) {
          var next = item.size - 0.5;
          if (pass === 0) {
            // The label is at its max width; the 2px of border does not scale with the font.
            var needed = item.width - item.client + item.scroll - 2;
            next = Math.min(next, Math.floor(item.size * (item.width - 2) / needed * 2) / 2);
          }
          item.size = Math.max(5, next);
          item.label.style.fontSize = item.size + 'px';
        });
        items = over;
      }
    }

    var resizeObserver = 'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          var labels = [];
          entries.forEach(function (entry) {
            var label = entry.target.querySelector('.wol');
            if (label) labels.push(label);
          });
          fitAll(labels);
        })
      : null;

    // Observing a zone fires the resize observer once right away, which does the first fit.
    function setup(zone) {
      zone.setAttribute('data-wol-ready', '');
      if (resizeObserver) {
        resizeObserver.observe(zone);
      } else {
        var label = zone.querySelector('.wol');
        if (label) fitAll([label]);
      }
    }

    // Only looks inside the given node (and the node itself), so new cards don't rescan the whole grid.
    function scan(root) {
      if (!root || !root.querySelectorAll) return;
      if (root.matches && root.matches('.wol-zone:not([data-wol-ready])')) setup(root);
      root.querySelectorAll('.wol-zone:not([data-wol-ready])').forEach(setup);
      if (root.matches && root.matches('.wol--inline:not([data-wol-ready])')) watchInline(root);
      root.querySelectorAll('.wol--inline:not([data-wol-ready])').forEach(watchInline);
    }

    // Product page: the gallery box can be taller than the photo (object-fit: contain leaves white bands),
    // so move the inline label onto the visible photo, 10px from its top-right corner.
    function activeImg(gallery) {
      return gallery.querySelector('.swiper-slide-active img') || gallery.querySelector('.swiper-slide img, img');
    }

    function placeInline(label) {
      var gallery = label.closest('swiper-component, media-gallery');
      if (!gallery) return;
      var img = activeImg(gallery);
      if (!img || !img.naturalWidth || !img.clientHeight) return;
      var boxW = img.clientWidth;
      var boxH = img.clientHeight;
      var contentW = boxW;
      var contentH = boxH;
      if (getComputedStyle(img).objectFit === 'contain') {
        var ratio = img.naturalWidth / img.naturalHeight;
        if (boxW / boxH > ratio) contentW = boxH * ratio;
        else contentH = boxW / ratio;
      }
      var imgRect = img.getBoundingClientRect();
      var labelRect = label.getBoundingClientRect();
      // The label rect already includes the current shift; adding it back (instead of clearing the
      // transform before measuring) keeps this a pure read, with no forced layout.
      var shiftX = parseFloat(label.getAttribute('data-wol-x')) || 0;
      var shiftY = parseFloat(label.getAttribute('data-wol-y')) || 0;
      var dx = Math.round(shiftX + (imgRect.right - (boxW - contentW) / 2 - 10) - labelRect.right);
      var dy = Math.round(shiftY + (imgRect.top + (boxH - contentH) / 2 + 10) - labelRect.top);
      if (dx === shiftX && dy === shiftY) return;
      label.setAttribute('data-wol-x', dx);
      label.setAttribute('data-wol-y', dy);
      label.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
    }

    // Watches one product-page label. A gallery re-rendered for another variant brings a new label,
    // which scan() picks up through the body mutation observer.
    function watchInline(label) {
      label.setAttribute('data-wol-ready', '');
      var gallery = label.closest('swiper-component, media-gallery');
      if (!gallery) return;
      var queued = false;
      var schedule = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; placeInline(label); });
      };
      // Only the photo on show matters; thumbnails and other slides load without moving the label.
      // Load events don't bubble, so listen in the capture phase; this also covers a photo whose src changes.
      gallery.addEventListener('load', function (event) {
        if (event.target === activeImg(gallery)) schedule();
      }, true);
      // Resize observer callbacks run right after layout, so measuring there forces no extra layout;
      // observing also fires once right away, which does the first placement.
      if ('ResizeObserver' in window) {
        var resize = new ResizeObserver(function () { placeInline(label); });
        resize.observe(gallery);
        var firstImg = gallery.querySelector('img');
        if (firstImg) resize.observe(firstImg);
      } else {
        schedule();
      }
      // The gallery can still move after the first placement (slider set-up, late styles).
      if (document.readyState !== 'complete') window.addEventListener('load', schedule, { once: true });
      // Slide changes (and the slider's set-up) move the "swiper-slide-active" class; the new photo
      // may have another ratio. Other class changes in the gallery (lazy loading, thumbnails) are ignored.
      var shown = gallery.querySelector('.swiper-slide-active');
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          var now = gallery.querySelector('.swiper-slide-active');
          if (now !== shown) {
            shown = now;
            schedule();
          }
        }).observe(gallery, { attributes: true, subtree: true, attributeFilter: ['class'] });
      }
      // The class moves when the slide starts moving; measure again once the slide has stopped.
      gallery.addEventListener('transitionend', function (event) {
        if (event.target.classList && event.target.classList.contains('swiper-wrapper')) schedule();
      });
    }

    function start() {
      scan(document);
      if ('MutationObserver' in window) {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) scan(node);
            });
          });
        }).observe(document.body, { childList: true, subtree: true });
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          fitAll(Array.prototype.slice.call(document.querySelectorAll('.wol-zone .wol')));
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
